import CartActionsContainer from './cart-actions-container';

export default CartActionsContainer;
